import axios from "axios";
import { showToastAction } from "../redux/toastSlice";

export default async function getProjectDashboard(projectName) {
    try {
        const res = await axios.get(`/project/${projectName}/dashboard`, {
            headers: { project_name: projectName }
        })
        return res.data;
    }
    catch (err) {
        store.dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        return err.response;
    }
}